import axios from "axios";
import React, { useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
  Spinner,
} from "reactstrap";
import Cookies from "universal-cookie";
import logo from "../../img/Simbolo_ICONTEC-2019-Pos.png";
import Swal from "sweetalert2";

const Login = () => {
  const cookie = new Cookies();
  const [postCorreo, setPostCorreo] = useState("");
  const [postContrasena, setPostContrasena] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const Microsoft = (e) => {
    window.location.href =
      "https://contratosback-dev.azurewebsites.net/api/v1/AuthAzure";
  };

  const postData = (e) => {
    e.preventDefault();
    setIsLoading(true);

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback-dev.azurewebsites.net/api/v1/AutenticaFormulario",
      data: {
        correo: postCorreo,
        contrasena: postContrasena,
      },
    })
      .then((response) => {
        const respuesta = response.data[0];
        cookie.set("id", respuesta.id, { path: "/" });
        cookie.set("correo", respuesta.correo, { path: "/" });
        cookie.set("tipo_Usuario", respuesta.tipoUsuarioId, { path: "/" });

        // Codificar correo a Base64 y hacerlo seguro para URL
        const correoBase64 = btoa(respuesta.correo);
        const correoSeguro = encodeURIComponent(correoBase64);

        Swal.fire({
          icon: "success",
          title: `¡Bienvenido!`,
          text: `${respuesta.correo}`,
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          window.location.href = `/admin/Solicitudes/${correoSeguro}`;
        });
      })

      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo iniciar sesión. Inténtalo de nuevo.",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Col lg="5" md="7">
      <Card className="bg-secondary shadow border-0">
        <CardHeader className="bg-transparent pb-5">
          <center>
            <img src={logo} width="100" alt="Logo Icontec" />
          </center>
          <center>CONTRATOS APP</center>
          <hr />
          <div className="btn-wrapper text-center">
            <Button
              className="btn-neutral btn-icon"
              color="default"
              onClick={Microsoft}
            >
              <span className="btn-inner--icon">
                <img
                  alt="Microsoft Logo"
                  src="https://purepng.com/public/uploads/large/purepng.com-microsoft-logo-iconlogobrand-logoiconslogos-251519939091wmudn.png"
                  width="20"
                />
              </span>
              <span className="btn-inner--text">Microsoft</span>
            </Button>
          </div>
        </CardHeader>
        <CardBody className="px-lg-3 py-lg-3">
          <Form role="form" onSubmit={postData}>
            <FormGroup className="mb-3">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-email-83" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Correo Electrónico"
                  type="email"
                  autoComplete="new-email"
                  onChange={(e) => setPostCorreo(e.target.value)}
                  required
                />
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-lock-circle-open" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Contraseña"
                  type="password"
                  autoComplete="new-password"
                  onChange={(e) => setPostContrasena(e.target.value)}
                  required
                />
              </InputGroup>
            </FormGroup>
            <div className="text-center">
              <Button
                className="my-4"
                color="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? <Spinner size="sm" /> : "Acceder"}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Login;
